import { Component, Watch } from "vue-property-decorator";
import Template from "@/components/BaseCurd/template";
import { EmployeeServiceProxy } from "@/service-proxies/app-v2/employee.service-proxies";
import { ServiceProxy } from "@/service-proxies/app-v2/resource.service-proxies";
import { AuthorityDomainServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
import R from "ramda";

import '@/components/tableStyle/index.less'

import {
  exportEmployee,
  importEmployee,
  downloadEmployeeTemplate,
} from "@/api/api";

const adsp = new AuthorityDomainServiceProxy();
// const oesp = new OssEndpointServiceProxy();
const oesp = new ServiceProxy();
const service = new EmployeeServiceProxy();
const crsp = new CodeRuleServiceProxy();

@Component
export default class Employee extends Template {
  name = "employee";
  visable = false;
  dateList = [];
  deptName = "";
  val = "";
  options = {
    retrieve: service.getPageEmployees.bind(service),
    search: service.getEmployee.bind(service),
    create: service.createOrUpdateEmployee.bind(service),
    update: service.createOrUpdateEmployee.bind(service),
    delete: service.deleteEmployee.bind(service),
    placeFile: service.createOrUpdateEmployee.bind(service),
    reset: service.resetEmployee.bind(service),
  };
  acl = {
    create: "page_employee_create",
    update: "page_employee_update",
    delete: "page_employee_delete",
    reset: "page_employee_reset",
  };

  scroll = {};

  ie = true;
  importFilename = "员工.xlsx";
  exportFilename = "员工.xlsx";

  downloadFn = downloadEmployeeTemplate;
  importFn = importEmployee;
  exportFn = exportEmployee;
  isShowPlaceFile = true;
  isShowReset = true;
  newResFlag = true;
  render() {
    return this.customRender();
  }
  getChange(val) {
    // console.log("val", val);
    this.visable = !!val;
    this._form_2.form.setFieldsValue({["code"]:""})
    // console.log(11111,this._form_2.form.getFieldValue('code'))
  }

  @Watch("showDialog")
  handleDialogChange(val) {
    if (val === true) {
      // console.log(1111, val);
      this.visable = false;
      this.deptName = ""
    }
  }

  getDeptname(val) {
    if (val) {
      this.val =val 
      this.dateList.find(item =>{this.forName(item) })
    }
    // if (tranformTreeShape(this.dateList[0]).value === val) {
    //   this.deptName = tranformTreeShape(this.dateList[0]).label;
    // } else if (tranformTreeShape(this.dateList[0]).children>0) {
    //   let code = tranformTreeShape(this.dateList[0]).children.find(
    //     (items) => items.value === val
    //   );
    //   if(code&&code.hasOwnProperty('label'))
    //   this.deptName = code.label;
    // }
    // console.log(11111, this.dateList);
  }

  forName(item) {
    if(item.id === this.val)
    this.deptName = item.title
     if(item&&item.hasOwnProperty('children'))
     if(item.children.length>0)
     item.children.find(items =>{this.forName(items)})
    console.log(11111,this.deptName)
  }


  get columns() {
    return [
      { title: this.$t("page_employee_code"), dataIndex: "code", width: 250 },
      { title: this.$t("page_employee_name"), dataIndex: "name", width: 200 },
      { title: this.$t("page_employee_email"), dataIndex: "email", width: 350 },
      { title: this.$t("page_employee_tel"), dataIndex: "tel" },
      { title: this.$t("page_authority_jurisdiction"), dataIndex: "deptName" },
    ];
  }

  get schema() {
    return {
      photoUrl: {
        label: this.$t("page_employee_photo"),
        type: "upload",
        props: {
          placeholder: this.$t("page_employee_add_photo"),
        },
        // async: oesp.putFilePOST.bind(oesp),
        async: oesp.putFileUsingPOST.bind(oesp),
        customStyle: {
          marginBottom: "0px !important",
        },
      },
      codeRuleId: {
        label: this.$t("page_system_coding_rules"),
        type: "select",
        display: this.showDrawer ? "none" : "block",
        placeholder: this.$t("page_system_select_coding_rule"),
        props: {
          allowClear: true,
          maxLength: 128,
        },
        options: async () => {
          const list = await crsp.list("EmployeeObject");
          // console.log("qqqqqqq",data)
          return list.map((item) => ({ label: item.name, value: item.id }));
        },
        on: {
          change: this.getChange,
        },
        // onClick: this.getList(),
        disabled: true,
      },
      code: {
        label: this.$t("page_employee_code"),
        type: "input",
        placeholder: this.$t("page_employee_add_code"),
        props: {
          maxLength: 32,
          disabled: this.visable = this.showDrawer ? true : this.visable,
        },
        rules: [
          {
            required: !this.visable,
            message: this.$t("page_employee_add_code"),
          },
        ],
      },
      name: {
        label: this.$t("page_employee_name"),
        type: "input",
        placeholder: this.$t("page_employee_add_name"),
        props: {
          maxLength: 32,
        },
        rules: [
          {
            required: true,
            message: this.$t("page_employee_add_name"),
          },
        ],
      },
      email: {
        label: this.$t("page_employee_email"),
        type: "input",
        placeholder: this.$t("page_employee_add_email"),
        props: {
        },
        rules: [
          {
            type: "email",
            message: this.$t("page_personal_email_valid_tip"),
          },
        ],
      },
      tel: {
        label: this.$t("page_employee_tel"),
        type: "input",
        placeholder: this.$t("page_employee_add_tel"),
        props: {
        },
        rules: [
          {
            pattern: /^1\d{10}$/,
            message: this.$t("page_personal_phone_valid_tip"),
          },
        ],
      },
      hireDate: {
        label: this.$t("page_employee_date"),
        type: "datePicker",
        placeholder: this.$t("page_employee_add_date"),
        props: {
        },
        format: "YYYY-MM-DD",
      },
      jobNumber: {
        label: this.$t("page_employee_no"),
        type: "input",
        placeholder: this.$t("page_employee_add_no"),
        props: {
          maxLength: 32,
        },
      },
      pinCode: {
        label: this.$t("page_employee_pin"),
        type: "password",
        placeholder: this.$t("page_employee_add_pin"),
        props: {
          maxLength: 32,
        },
      },
      deptId: {
        label: this.$t("page_authority_jurisdiction"),
        type: "treeSelect",
        placeholder: this.$t('page_docdirectory_jurisdiction_choose_auth'),
        props: {
          allowClear: true,
          showSearch:true,
          treeNodeFilterProp:"title"
        },
        options: async () => {
          const { data } = await adsp.getEnableTreeList();
          this.dateList = data;
          return [tranformTreeShape(data[0])];
        },
        on: { change: this.getDeptname },
      },
    };
  }

  async createData() {
    const data: any = await this._form_2.manualSubmit();
    this.saveLoading = true;
    const list = {deptName:this.deptName}
    Object.assign(data, list);
    // console.log(2222,data)
    const fetchFn = this.options.create;
    try {
      await fetchFn(data)
      this.saveLoading = false
      this.$message.success(this.$t('page_docdirectory_create_success'))
      this.showDialog = false
      this.getData()
    } catch (e) {
      this.saveLoading = false
    }
  }

  async updateData() {
    const values: any = await this._form_1.manualSubmit()
    this.saveLoading = true
    const data = {
      ...this.editdata,
      ...values,
      deptName:this.deptName
    }
    const fetchFn = this.options.update
    try {
      await fetchFn(data)
      this.saveLoading = false
      this.$message.success(this.$t('page_docdirectory_edit_success'))
      this.showDrawer = false
      this.getData()
    } catch (e) {
      this.saveLoading = false
    }
  }

  renderHeader(slot = null) {
    const { hidden } = this;

    const add = hidden.includes("create") ? null : (
      <a-button
        v-acl={this.acl.create}
        type="primary"
        style={{ marginRight: "8px" }}
        onClick={this.openCreateWindow}
      >
        {this.lang.create}
      </a-button>
    );

    const del = hidden.includes("delete") ? null : (
      <a-popconfirm
        title={this.$t("page_resource_pool_confirm_delete")}
        onConfirm={this.deleteData}
        okText={this.$t("yes")}
        cancelText={this.$t("no")}
        disabled={this.selectedIds.length < 1}
      >
        <a-button
          v-acl={this.acl.delete}
          type="danger"
          disabled={this.selectedIds.length < 1}
        >
          {this.lang.delete}
        </a-button>
      </a-popconfirm>
    );

    const printing = hidden.includes("printing") ? null : (
      <a-button
        type="default"
        style={{ marginLeft: "8px" }}
        onClick={() =>this.printing()}
        disabled={this.selectedIds.length === 0}
      >
        {this.$t("page_print_code")}
      </a-button>
    );

    return (
      <div
        slot="action"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          {add}
          {del}
          {this.ie ? this.extraHeaderAction() : null}
          {printing}
        </div>
        {this.showSearch ? ( <div style="display:flex;align-items:center">
          {slot}
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
          ></a-input-search>
        </div>) : null}
      </div>
    );
  }

}
const resetProp = (from, to) => R.pipe(R.prop(from), R.objOf(to));

const tranformTreeShape = (data) => {
  const setLabel = resetProp("title", "label");
  const setValue = resetProp("id", "value");
  const setChildren = R.pipe(
    R.prop("children"),
    R.ifElse(
      R.either(R.isNil, R.isEmpty),
      R.empty,
      R.pipe(R.map(tranformTreeShape), R.objOf("children"))
    )
  );

  return R.converge(R.unapply(R.mergeAll), [setLabel, setValue, setChildren])(
    data
  );


};




